import {
  getDsjapiList,
  queryGoodsList
} from "@/api/goods/goods";

export default {
  namespaced: true,
  state: {
    list: []
  },
  actions: {
    async getDsjapiList(context, params) {
      const { data } = await getDsjapiList(params);
      return data;
    },
    async queryGoodsList(context, params) {
      const data = await queryGoodsList(params);
      return data;
    }

  }
};
